var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h"},[_c('div',{staticClass:"content-tool-bar"},[_vm._v(" 链接： "),_vm._l((_vm.carouselList),function(item){return _c('a',{attrs:{"href":item.url,"target":"_blank"}},[_vm._v(_vm._s(item.name))])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }